import { Component, Output, EventEmitter, Input } from '@angular/core';
import { SystemService } from '../../services/system.service';
import { Observable } from "rxjs/Observable";
import { ProjectService } from '../../services/project.service';
import { AssetService } from '../../services/asset.service';
import { Project } from '../../models/project.model';
import { Asset } from '../../models/asset.model';
/**
 * Created On : 19th Feb 2018
 * Usage : Displays list of assets 
 * Coprights : Johnson Controls India Pvt Ltd.
 **/
@Component({
    selector: 'systems',
    templateUrl: 'systems.html'
})
export class SystemsComponent {
    public selectedSystem: Asset;
    public showModal: boolean;
    public project: Project;
    @Output() changeSystem = new EventEmitter();
    
    constructor(
        private systemService: SystemService,
        private projectService: ProjectService,
        private assetService: AssetService
    ) {
       this.systemService.showModalEventEmitter.subscribe((value) => this.showModal = value);
       this.project = this.projectService.get();
    }

    close() {
        this.showModal = false;
        this.systemService.set(this.showModal);
    }

    changeSystemFn(selectedAsset: Asset){
        this.selectedSystem = selectedAsset;
        this.assetService.set(selectedAsset);
        this.changeSystem.emit(selectedAsset);
    }
}



// WEBPACK FOOTER //
// ./src/components/systems/systems.ts